"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var unitsList_1 = require("common/global/unitsList");
var warehousesList_1 = require("common/global/warehousesList");
var useTitle_1 = __importDefault(require("portal/hooks/useTitle"));
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var warehouseItemsSlice_1 = require("src/features/warehouseItems/warehouseItemsSlice");
var moment_1 = __importDefault(require("moment"));
function WarehouseMovementsTable(props) {
    var _a = (0, reduxHooks_1.useAppSelector)(function (state) { return state.warehouseItems; }), warehouseItemMovementByStockNumber = _a.warehouseItemMovementByStockNumber, status = _a.status;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    console.log({ warehouseItemMovementByStockNumber: warehouseItemMovementByStockNumber });
    var t = (0, react_i18next_1.useTranslation)().t;
    var params = (0, react_router_dom_1.useParams)();
    var batchNumber = params.batchNumber || props.batchNumber;
    var stockNumber = params.stockNumber || props.stockNumber;
    var serialNumber = params.serialNumber || props.serialNumber;
    var assetNumber = params.assetNumber || props.assetNumber;
    (0, useTitle_1.default)(t("warehouse.movement", { stockNumber: stockNumber }));
    (0, react_1.useEffect)(function () {
        dispatch((0, warehouseItemsSlice_1.fetchWarehouseItemMovementByStockNumber)(stockNumber));
    }, [dispatch]);
    var warehouseItems = warehouseItemMovementByStockNumber;
    var columnsOfItems = (0, react_1.useMemo)(function () { return [
        {
            name: "cachedProductName",
            title: t("products.productName"),
        },
        {
            name: "cachedProductUnit",
            title: t("common.unit"),
            getCellValue: function (r) { var _a; return (_a = unitsList_1.globalUnitsData[r.cachedProductUnit]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "cachedProductDescription",
            title: t("products.description"),
        },
        {
            name: "warehouseId",
            title: t("warehouse.warehouse"),
            getCellValue: function (r) { var _a; return r.warehouseId ? (_a = warehousesList_1.globalWarehousesData[r.warehouseId]) === null || _a === void 0 ? void 0 : _a.name : null; },
        },
        {
            name: "fromWarehouse",
            title: t("warehouse.fromWarehouse"),
            getCellValue: function (r) {
                var _a;
                return r.fromWarehouseId
                    ? (_a = warehousesList_1.globalWarehousesData[r.fromWarehouseId]) === null || _a === void 0 ? void 0 : _a.name
                    : null;
            },
        },
        {
            name: "toWarehouse",
            title: t("warehouse.toWarehouse"),
            getCellValue: function (r) { var _a; return r.toWarehouseId ? (_a = warehousesList_1.globalWarehousesData[r.toWarehouseId]) === null || _a === void 0 ? void 0 : _a.name : null; },
        },
        {
            name: "operationType",
            title: t("warehouse.operationType"),
        },
        {
            name: "serialNumbers",
            title: t("warehouse.serialNumbers"),
            getCellValue: function (r) {
                var _a;
                return typeof r.serialNumbers == "string"
                    ? r.serialNumbers
                    : (_a = r.serialNumbers) === null || _a === void 0 ? void 0 : _a.join(", ");
            },
        },
        {
            name: "quantity",
            title: t("common.quantity"),
        },
        {
            name: "before",
            title: "Before",
        },
        {
            name: "after",
            title: "After",
        },
        {
            name: "status",
            title: t("common.status"),
        },
        {
            name: "expiryDate",
            title: t("warehouse.expiryDate"),
            getCellValue: function (r) {
                return (0, moment_1.default)(r.expiryDate).format("DD/MM/YYYY");
            },
        },
        {
            name: "createdAt",
            title: t("warehouse.createdAt"),
            getCellValue: function (r) {
                return (0, moment_1.default)(r.createdAt).format("DD/MM/YYYY");
            },
        },
    ]; }, [t]);
    if (status == "loading") {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(antd_1.Tabs, __assign({ tabBarStyle: { paddingLeft: 8 } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Tabs.TabPane, __assign({ tab: "Movements" }, { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: warehouseItems, columns: columnsOfItems, getRowId: function (r) { return r.createdAt; } }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({}), true) })) }), "movements") })) }));
}
exports.default = WarehouseMovementsTable;
